import AxiosInstance from "@/api/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserManual } from "./userManualSlice";

export const fetchUserManualUrl = createAsyncThunk(
  "fetchManualUrl/fetchData",
  async () => {
    try {
      const response = await AxiosInstance.get("/manual/url");
      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  },
);

interface IUserManualState {
  manual: IUserManual | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: IUserManualState = {
  manual: undefined,
  loading: false,
  error: null,
};

const manualReducer = createSlice({
  name: "manual",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserManualUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserManualUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.manual = action.payload;
      })
      .addCase(fetchUserManualUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default manualReducer.reducer;
